import { FieldValidator, useField } from 'formik'

interface SkuSelectInputProps {
  name: string
  validate?: FieldValidator
  type?: 'physical_kit'
}

const SkuSelectInput = ({ name, validate, type }: SkuSelectInputProps) => {
  const [field, meta] = useField<string>({ name, validate })

  return (
    <div className="field">
      <label className="label">SKU</label>
      <div className="control">
        <div className="select">
          <select name={name} {...field}>
            <option value="ncov">ncov</option>
            <option value="ncov_travel">ncov_travel</option>
            <option value="ncov_release">ncov_release</option>
            <option value="tdl_pcr">tdl_pcr</option>
            <option value="gcov">gcov</option>
            <option value="tcov">tcov</option>
            <option value="scov">scov</option>
            <option value="rapid_ag">rapid_ag</option>
            <option value="rapid_travel">rapid_travel (Healgen Antigen)</option>
            <option value="rapid_travel_hughes">rapid_travel_hughes (Hughes Antigen)</option>
            <option value="rapid_multi">rapid_multi</option>
            <option value="day2">day2</option>
            {type !== 'physical_kit' && <option value="day2_lfd">day2_lfd</option>}
            <option value="day8">day8</option>
            <option value="day2and8">day2and8</option>
            <option value="salient_pcr">salient_pcr</option>
            <option value="supervision">supervision</option>
            <option value="supervised_rat">supervised_rat</option>
          </select>
        </div>

        {meta.touched && meta.error && <p className="help is-danger">{meta.error}</p>}
      </div>
    </div>
  )
}

export default SkuSelectInput
